import { notFound } from "@tanstack/react-router";
import pages from "virtual:maito-content";
export { contentHead } from "./head";

export function loadContentPage(path: string) {
  const page = pages[path];
  if (!page) throw notFound();
  return page;
}
